import * as messageService from "../../services/message.service";
import * as residentialStatusService from '../../services/residentialStatus.service';


const state = {
    residentialStatusAll:[],
    residentialStatusAllActive:[],
};

const getters = {
    gettResidentialStatusAll:state => (state.residentialStatusAll),
    gettResidentialStatusActive:state => (state.residentialStatusAllActive),
};

const actions = {
    async fetchResidentialStatusAll({ commit } ){
        try {
            const response = await residentialStatusService.all();
            commit('setResidentialStatusAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchResidentialStatusAllActive({ commit } ){
        try {
            const response = await residentialStatusService.allActive();
            commit('setResidentialStatusAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setResidentialStatusAll:(state, res) => (
        state.residentialStatusAll =  res
    ),
    setResidentialStatusAllActive:(state, res) => (
        state.residentialStatusAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}